export default {
  setGoalUsers(state, data) {
    state.goalUsers = data;
  },

  setGoalSchedules(state, data) {
    state.goalSchedules = data;
  },

  setGoals(state, data) {
    state.goals = data;
  },
  setGoal(state, data) {
    state.goal = data;
  },
  setGoalDetail(state, data) {
    state.goalDetail = data;
  },
  setGoalId(state, data) {
    state.goalId = data;
  },
  setGoalCode(state, data) {
    state.goalCode = data;
  },

  setTaskCategorys(state, data) {
    state.taskCategorys = data;
  },
  setTaskCategory(state, data) {
    state.taskCategory = data;
  },
  setTaskCategoryCode(state, data) {
    state.taskCategoryCode = data;
  },

  setNoteCategorys(state, data) {
    state.noteCategorys = data;
  },
  setNoteCategory(state, data) {
    state.noteCategory = data;
  },
  setNoteCategoryCode(state, data) {
    state.noteCategoryCode = data;
  },

  setProjectTypes(state, data) {
    state.projectTypes = data;
  },
  setProjectType(state, data) {
    state.projectType = data;
  },
  setProjectTypeCode(state, data) {
    state.projectTypeCode = data;
  },

  setWorkDescriptions(state, data) {
    state.workDescriptions = data;
  },
  setWorkDescription(state, data) {
    state.workDescription = data;
  },
  setWorkDescriptionCode(state, data) {
    state.workDescriptionCode = data;
  },

  setNoteSubjects(state, data) {
    state.noteSubjects = data;
  },
  setNoteSubject(state, data) {
    state.noteSubject = data;
  },
  setNoteSubjectCode(state, data) {
    state.noteSubjectCode = data;
  },

  setRequestTypes(state, data) {
    state.requestTypes = data;
  },
  setRequestType(state, data) {
    state.requestType = data;
  },
  setRequestTypeCode(state, data) {
    state.requestTypeCode = data;
  },

  setCallSubjects(state, data) {
    state.callSubjects = data;
  },
  setCallSubject(state, data) {
    state.callSubject = data;
  },
  setCallSubjectCode(state, data) {
    state.callSubjectCode = data;
  },

  setCallCategories(state, data) {
    state.callCategories = data;
  },
  setCallCategory(state, data) {
    state.callCategory = data;
  },
  setCallCategoryCode(state, data) {
    state.callCategoryCode = data;
  },

  setServiceSupportSubjects(state, data) {
    state.serviceSupportSubjects = data;
  },
  setServiceSupportSubject(state, data) {
    state.serviceSupportSubject = data;
  },
  setServiceSupportSubjectCode(state, data) {
    state.serviceSupportSubjectCode = data;
  },
  setServiceSupports(state, data) {
    state.serviceSupports = data;
  },
  setServiceSupport(state, data) {
    state.serviceSupport = data;
  },
  setServiceSupportCode(state, data) {
    state.serviceSupportCode = data;
  },
  setContracts(state, data) {
    state.contracts = data;
  },
  setContract(state, data) {
    state.contract = data;
  },
  setContractCode(state, data) {
    state.contractCode = data;
  },
  setSetting(state, data) {
    state.setting = data;
  },

  setTasks(state, data) {
    state.tasks = data;
  },
  setTask(state, data) {
    state.task = data;
  },
  setTaskTimer(state, { id, timer }) {
    state.taskTimers = { ...state.taskTimers, [id]: timer };
  },
  removeTaskTimer(state, id) {
    const timers = { ...state.taskTimers };
    delete timers[id];
    state.taskTimers = timers;
  },
  setTaskId(state, data) {
    state.taskId = data;
  },
  setTaskCode(state, data) {
    state.taskCode = data;
  },
  setTaskNavigation(state, data) {
    state.taskNavigation = data;
  },

  setTaskTeams(state, data) {
    state.taskTeams = data;
  },
  setTaskTeam(state, data) {
    state.taskTeam = data;
  },

  setMessages(state, data) {
    state.messages = data;
  },
  setMessage(state, data) {
    state.message = data;
  },
  setMessageCode(state, data) {
    state.messageCode = data;
  },

  setCalls(state, data) {
    state.calls = data;
  },
  setCall(state, data) {
    state.call = data;
  },
  setCallCode(state, data) {
    state.callCode = data;
  },

  setRequests(state, data) {
    state.requests = data;
  },
  setRequest(state, data) {
    state.request = data;
  },
  setRequestCode(state, data) {
    state.requestCode = data;
  },

  setNotes(state, data) {
    state.notes = data;
  },
  setNote(state, data) {
    state.note = data;
  },
  setNoteCode(state, data) {
    state.noteCode = data;
  },

  setMeetings(state, data) {
    state.meetings = data;
  },
  setMeeting(state, data) {
    state.meeting = data;
  },
  setMeetingCode(state, data) {
    state.meetingCode = data;
  },
  setMeetingId(state, data) {
    state.meetingId = data;
  },

  setProjects(state, data) {
    state.projects = data;
  },
  setProject(state, data) {
    state.project = data;
  },
  setProjectId(state, data) {
    state.projectId = data;
  },
  setProjectCode(state, data) {
    state.projectCode = data;
  },

  setProjectTeams(state, data) {
    state.projectTeams = data;
  },
  setProjectTeam(state, data) {
    state.projectTeam = data;
  },

  setReminders(state, data) {
    state.reminders = data;
  },
};
